/** Оставляет только дополнительные титулы, для которых получены реальные данные. */
export function filterExistingEdoAdditionalTitleCards({
  cards = [],
  details = [],
}) {
  const existingKeys = new Set(
    details.filter((item) => item.hasData).map((item) => item.key),
  );

  return cards.filter((card) => existingKeys.has(card.key));
}
